// MOTON セルフラッピング（ショッパー・巾着）の追加。snippets/moton-gift-wrap.liquid と組で使う。
// テーマ（Hyper）本体には手を入れず、テーマが出す合図だけを使う:
//   ・商品をカートに入れられたとき document に "product-ajax:added" が飛ぶ
//   ・document に "cart:refresh"（detail.open=true）を飛ばすと、右から出るカートを読み直して開く
(() => {
  if (window.__motonGiftWrap) return;
  window.__motonGiftWrap = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  async function addToCart(items) {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.description || body.message || 'カートに追加できませんでした');
    }
  }

  function refreshCart(context) {
    // カートページは画面ごと読み直す（右から出るカートとは別の作り）
    if (context === 'cart_page') {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
  }

  // 商品ページ: 商品がカートに入ったら、チェックしてあるラッピングも入れる
  document.addEventListener('product-ajax:added', async () => {
    const checks = Array.from(
      document.querySelectorAll('[data-moton-wrap][data-context="product"] [data-moton-wrap-check]:checked')
    );
    if (checks.length === 0) return;
    try {
      await addToCart(checks.map((c) => ({ id: Number(c.value), quantity: 1 })));
      checks.forEach((c) => { c.checked = false; });
      refreshCart('product');
    } catch (e) {
      console.error('[moton-gift-wrap]', e);
      window.alert('ショッパー・巾着をカートに追加できませんでした。お手数ですがカートから追加してください。\n' + e.message);
    }
  });

  // ショッパー・巾着だけのカートでは決済に進ませない（ボタンは CSS で押せなくしてあるが、Enter キー等の送信も止める）
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const toCheckout = (event.submitter && event.submitter.name === 'checkout') || form.querySelector('[name="checkout"]');
    if (!toCheckout) return;
    if (document.querySelector('[data-moton-wrap-only]')) {
      event.preventDefault();
      window.alert('ショッパー・巾着のみのご購入はできません。MOTONの商品と一緒にご注文ください。');
    } else if (document.querySelector('[data-moton-wrap-over]')) {
      event.preventDefault();
      window.alert('ショッパー・巾着は対象商品1点につき各1点までです。数量を調整していますので、少々お待ちください。');
    }
  }, true);

  // 特典アプリ（Order Bonus）が特典を足したり外したりすると「ページを更新してください」のお知らせ（dialog）を出すが、
  // テーマの独自CSSが「カートが開いている間はアプリごと非表示」にしているため、お知らせは見えず暗い膜だけが残って
  // スマホでタップが効かなくなる（2026-10-17）。見えない状態で開いたら閉じて、カートを読み直す（特典の増減が反映される）。
  (function watchOrderBonus(tries) {
    const host = document.querySelector('ruffruff-order-bonus-app');
    if (!host || !host.shadowRoot) {
      if (tries < 20) setTimeout(() => watchOrderBonus(tries + 1), 1000);
      return;
    }
    const sr = host.shadowRoot;
    const handle = () => {
      const dialog = sr.querySelector('dialog.rob-popup[open]');
      if (!dialog || getComputedStyle(host).display !== 'none') return;
      dialog.close();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
    };
    new MutationObserver(handle).observe(sr, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
    handle();
    // 特典の🎁ボタン（rob-floating-button）は設定の「下から 140px」を bottom に入れるのに、top も入れていて top が勝つ。
    // スマホでは下のメニュー（mobile-sticky-bar）の「カート」に重なっていた（2026-10-18）。
    // 下のメニューが出ているときだけ、設定どおり下から bottom の高さ（チャットの上）に置き直す。
    const placeFloating = () => {
      const btn = sr.querySelector('button.rob-floating-button');
      const bar = document.querySelector('mobile-sticky-bar');
      if (!btn || !bar || bar.getBoundingClientRect().height === 0 || getComputedStyle(bar).display === 'none') return;
      const bottom = parseFloat(btn.style.bottom) || 140;
      const h = btn.getBoundingClientRect().height || 60;
      const top = Math.round(document.documentElement.clientHeight - bottom - h);
      if (Math.abs((parseFloat(btn.style.top) || 0) - top) > 1) btn.style.setProperty('top', `${top}px`, 'important');
    };
    new MutationObserver(placeFloating).observe(sr, { subtree: true, childList: true, attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', placeFloating);
    placeFloating();
  })(0);

  // ショッパー・巾着は対象商品1点につき各1点まで（2026-10-17）。超えているとスニペットが
  // data-moton-wrap-over（減らす先の数量 data-fix＝[[行のキー, 数量], …]）を出すので、カートの数量を直して読み直す。
  // カートは開くたび・数量を変えるたびに描き直されるので、DOM の変化を見て拾う。同じ内容で二度は直さない。
  let lastFix = '';
  let fixing = false;
  async function fixWrapOver() {
    const el = document.querySelector('[data-moton-wrap-over]');
    if (!el) { lastFix = ''; return; }
    const fix = el.dataset.fix || '';
    if (fixing || !fix || fix === lastFix) return;
    let updates;
    try { updates = Object.fromEntries(JSON.parse(fix)); } catch (e) { return; }
    if (!Object.keys(updates).length) return;
    fixing = true;
    lastFix = fix;
    try {
      const res = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!res.ok) throw new Error('数量を変更できませんでした');
      refreshCart(el.dataset.context || 'cart');
    } catch (e) {
      console.error('[moton-gift-wrap]', e);
    } finally {
      fixing = false;
    }
  }
  // 間引きは「待ってから1回」ではなく「150ms に1回まで」。トップページのように DOM が絶えず動く画面では、
  // 変化のたびに待ち直す作りだと一度も走らない（2026-10-17 に実際そうなった）
  let fixTimer = null;
  new MutationObserver(() => {
    if (fixTimer) return;
    fixTimer = setTimeout(() => { fixTimer = null; fixWrapOver(); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
  fixWrapOver();

  // カート: 「追加」ボタン
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-moton-wrap-add]');
    if (!button) return;
    event.preventDefault();
    const box = button.closest('[data-moton-wrap]');
    const label = button.textContent;
    button.disabled = true;
    button.textContent = '追加中…';
    try {
      await addToCart([{ id: Number(button.dataset.motonWrapAdd), quantity: 1 }]);
      refreshCart(box ? box.dataset.context : 'cart');
    } catch (e) {
      console.error('[moton-gift-wrap]', e);
      button.disabled = false;
      button.textContent = label;
      window.alert('カートに追加できませんでした。\n' + e.message);
    }
  });
})();
